import slice from './slice';

export const { setPreference, setPreferences } = slice.actions;
export default slice.reducer;
